module.exports = __webpack_public_path__ + "img/IMG_2236.38b87678.jpg";